import { QueryKey } from '@tanstack/react-query';
import { HomeTabListOption } from '../../types/home/tab';
import { HomeListOptionV2 } from '../../types/home/list';

export const homeQueryKeys = {
  homeList: (option: HomeListOptionV2): QueryKey => ['home', 'list', option],
  tabList: (option: HomeTabListOption): QueryKey => ['home', 'tab', 'list', option],
};
